import { render, staticRenderFns } from "./SetBanner.vue?vue&type=template&id=32365fa2&scoped=true&"
import script from "./SetBanner.vue?vue&type=script&lang=js&"
export * from "./SetBanner.vue?vue&type=script&lang=js&"
import style1 from "./SetBanner.vue?vue&type=style&index=1&id=32365fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32365fa2",
  null
  
)

export default component.exports